import './App.css';
import ArticleList from './components/ArticleList';

function App() {
  return (
    <div className="App">
      <ArticleList />
    </div>
  );
}

export default App;
